import "@progress/kendo-theme-material/dist/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-confirm-alert/src/react-confirm-alert.css";

import "alertifyjs/build/css/alertify.min.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "./css/adminlte.min.css";
import "./css/fontawesome-free/css/all.min.css";
import "./css/index.css";

import axios from "axios";

import currencyData from "cldr-core/supplemental/currencyData.json";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import weekData from "cldr-core/supplemental/weekData.json";
import caGregorianTr from "cldr-dates-full/main/tr/ca-gregorian.json";
import dateFieldsTr from "cldr-dates-full/main/tr/dateFields.json";
import timeZoneNamesTr from "cldr-dates-full/main/tr/timeZoneNames.json";
import currenciesTr from "cldr-numbers-full/main/tr/currencies.json";
import numbersTr from "cldr-numbers-full/main/tr/numbers.json";
import caGregorianEn from "cldr-dates-full/main/en/ca-gregorian.json";
import dateFieldsEn from "cldr-dates-full/main/en/dateFields.json";
import timeZoneNamesEn from "cldr-dates-full/main/en/timeZoneNames.json";
import currenciesEn from "cldr-numbers-full/main/en/currencies.json";
import numbersEn from "cldr-numbers-full/main/en/numbers.json";
import caGregorianAr from "cldr-dates-full/main/ar/ca-gregorian.json";
import dateFieldsAr from "cldr-dates-full/main/ar/dateFields.json";
import timeZoneNamesAr from "cldr-dates-full/main/ar/timeZoneNames.json";
import currenciesAr from "cldr-numbers-full/main/ar/currencies.json";
import numbersAr from "cldr-numbers-full/main/ar/numbers.json";

import i18next from "i18next";
import React from "react";
import ReactDOM from "react-dom/client";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import translationAR from "../src/i18n/ar.json";
import translationEN from "../src/i18n/en.json";
import translationTR from "../src/i18n/tr.json";
import App from "./App";
import "./assets/styles/index.css";
import "./config/languageInit";
import i18n from "./config/languageInit";
import reportWebVitals from "./reportWebVitals";
import { authorizationToken } from "./helpers/authorizationToken";
import {
  IntlProvider,
  load,
  loadMessages,
  LocalizationProvider,
} from "@progress/kendo-react-intl";

load(
  likelySubtags,
  currencyData,
  weekData,
  // Turkish
  caGregorianTr,
  dateFieldsTr,
  currenciesTr,
  timeZoneNamesTr,
  numbersTr,
  // English
  caGregorianEn,
  dateFieldsEn,
  timeZoneNamesEn,
  currenciesEn,
  numbersEn,
  // Arabic
  caGregorianAr,
  dateFieldsAr,
  timeZoneNamesAr,
  currenciesAr,
  numbersAr
);

loadMessages(translationEN, "en");
loadMessages(translationAR, "ar");
loadMessages(translationTR, "tr");
const jwtToken = localStorage.getItem("jwtToken");

if (jwtToken) {
  authorizationToken(jwtToken);
}
document.documentElement.lang = i18n.language;
const root = ReactDOM.createRoot(document.getElementById("root"));
axios.defaults.headers.common["Accept-Language"] = i18n.language;

root.render(
  <LocalizationProvider language={i18next.language}>
    <IntlProvider locale={i18next.language}>
      <App />
    </IntlProvider>
  </LocalizationProvider>
);

reportWebVitals();
